"use strict";

angular.module("vendor")
.controller("ProductVariantModalController", function(
    $scope, $attrs, $filter, close, common, FormError, ProductService, BarcodeFormatsService, CoreProductVariantService
) {
    var _this = this;
    $scope.productVariant = $attrs.productVariant;
    $scope.variantOptions = $attrs.variantOptions;
    $scope.INVENTORY_QUANTITY_MAX = ProductService.INVENTORY_QUANTITY_MAX;
    $scope.isProductInventoryAvailable = $attrs.isProductInventoryAvailable;
    $scope.setInventoryQuantityZero = $attrs.setInventoryQuantityZero;
    $scope.barcodeFormats = BarcodeFormatsService.query();
    $scope.barcodeFormats.$promise.then(function() {
        _this.selectedBarcodeFormat($scope.productVariant.barcode_format);
    });

    this.getProductVariantName = function(optionValues) {
        return CoreProductVariantService.getProductVariantName($scope.variantOptions, optionValues);
    };

    this.selectedBarcodeFormat = function(selectedFormat) {
        $scope.currentBarcodeFormat = $filter("getById")($scope.barcodeFormats, selectedFormat);
        if ($scope.currentBarcodeFormat && !$scope.currentBarcodeFormat.digit_count) {
            $scope.productVariant.upc = null;
        }
    };

    $scope.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();

        close.apply(this, arguments);
    };

    $scope.update = function() {
        $scope.productVariantForm.$setSubmitted();
        if (!$scope.productVariantForm.$valid) {
            FormError.focus("productVariantForm");
        }
        else {
            var productVariantCopy = angular.copy($scope.productVariant);
            var fileNames = ["image_upload"];
            var sendData = common.createFormDataFromFiles(productVariantCopy, fileNames);
            $scope.close(sendData);
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product-variants/modals/product-variant.modal.js
// module id = 897
// module chunks = 0